import { useApplicantContext } from '../contexts/ApplicantContext';
import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  description?: string;
  /** Extra actions/buttons rendered on the right of the header (e.g. Add scholarship). */
  action?: ReactNode;
  /** Whether to show the "Currently viewing [Applicant]" subtitle. Default true. */
  showApplicant?: boolean;
}

export function PageHeader({ title, description, action, showApplicant = true }: PageHeaderProps) {
  const { selectedApplicant, applicants } = useApplicantContext();
  const showsApplicantContext = showApplicant && selectedApplicant && applicants.length > 0;

  return (
    <header className="flex items-start justify-between gap-3 flex-wrap mb-4">
      <div className="min-w-0">
        <h1 className="text-2xl font-serif font-semibold text-ink">{title}</h1>
        {description && <p className="text-sm text-soft mt-1">{description}</p>}
        {showsApplicantContext && (
          <p className="text-xs text-soft mt-1">
            Currently viewing <span className="font-medium text-soft">{selectedApplicant.display_name}</span>
          </p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </header>
  );
}
